import { ArchivedOrganizerRequestParameter, BatchRequestBody, DeliveredOrganizerParameter, InProcessOrganizersRequestParameter, OrganizerCommonRequestBody, OrganizerDeleteInProcessRequestBody, OrganizerSendReminderRequestBody, OrganizerSignerDetailsRequestParameter, OrganizerStatusRequestParameter, ProformaRequestBody, RecycleBinOrganizerParameter, ResendAccessLinkRequestBody, SignerDetailsRequestParameter } from "../../common/model/sso/requestBody";
import { ArchivedOrganizerResponseBody, DeliveredOrganizerResponseBody, InProcessOrganizersResponseBody, OrganizerStatusResponseBody, RecycleBinOrganizerResponseBody, SignerDetailsResponseBody, UpdateDocumentStatusRequestBody } from "../../common/model/sso/responseBody";
import { SSO_Archived_APIs_commonParameter, SSO_ArchivedAPI_ArchivedOrganizersParameter, SSO_ArchivedAPI_SignerDetailsParameter, SSO_ArchivedAPIs_ResendAccessLinkParameters, SSO_DeliveredAPI_DeliveredOrganizerParameter, SSO_DeliveredAPI_SendReminderParameter, SSO_DeliveredAPI_SignerDetailsParameter, SSO_InProcessAPI_DeleteInProcessOrganizerParameter, SSO_InProcessAPI_GetAllParameter, SSO_OrganizerStatusAPI_GetOrganizerStatusParameter, SSO_OrganizerStatusAPI_updateDocumentStatusParameter, SSO_RecycleBinAPI_GetAllParameter, SSO_UploadAPI_BatchParameter, SSO_UploadAPI_ProformaParameter } from "../apiParameters";
import { baseResponseBody } from "../objectTypeConstants";

export const batchRequestBody: BatchRequestBody = {
  csvFileUri: SSO_UploadAPI_BatchParameter.csvFileUri,
  zipFileUri: SSO_UploadAPI_BatchParameter.zipFileUri,
  batchName: SSO_UploadAPI_BatchParameter.batchName,
  ero: SSO_UploadAPI_BatchParameter.ero,
  taxYear: SSO_UploadAPI_BatchParameter.taxYear,
  taxSoftware: SSO_UploadAPI_BatchParameter.taxSoftware,
  enableEngagementLetter: SSO_UploadAPI_BatchParameter.enableEngagementLetter,
  callbackUri: SSO_UploadAPI_BatchParameter.callbackUri,
  correlationId: SSO_UploadAPI_BatchParameter.correlationId,
  locationId: SSO_UploadAPI_BatchParameter.locationId
}

export const proformaRequestBody: ProformaRequestBody = {
  clientId: SSO_UploadAPI_ProformaParameter.clientId,
  eroUser: SSO_UploadAPI_ProformaParameter.eroUser,
  taxYear: SSO_UploadAPI_ProformaParameter.TaxYear,
  taxSoftware: SSO_UploadAPI_ProformaParameter.taxSoftware,
  taxReturnType: SSO_UploadAPI_ProformaParameter.taxReturnType,
  callbackUri: SSO_UploadAPI_ProformaParameter.callbackUri,
  correlationId: SSO_UploadAPI_ProformaParameter.correlationId,
  organizerDocument: SSO_UploadAPI_ProformaParameter.organizerDocument,
  organizerFileUrl: SSO_UploadAPI_ProformaParameter.organizerFileUrl,
  organizerFileName: SSO_UploadAPI_ProformaParameter.organizerFileName,
  engagementLetterDocument: SSO_UploadAPI_ProformaParameter.engagementLetterDocument,
  engagementLetterFileUrl: SSO_UploadAPI_ProformaParameter.engagementLetterFileUrl,
  engagementLetterFileName: SSO_UploadAPI_ProformaParameter.engagementLetterFileName,
  isEngagementLetterIncluded: SSO_UploadAPI_ProformaParameter.isEngagementLetterIncluded
}


export const archivedOrganizerRequestParameter: ArchivedOrganizerRequestParameter = {
  clientIdQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.clientIDQuery,
  clientNameQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.clientNameQuery,
  taxPayerEmailQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.taxPayerEmailQuery,
  spouseEmailQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.spouseEmailQuery,
  archivedBy: SSO_ArchivedAPI_ArchivedOrganizersParameter.archivedByQuery,
  taxYearQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.taxYearQuery,
  batchNameQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.batchNameQuery,
  eroQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.eroQuery,
  deliveredAfterQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.deliveredAfterQuery,
  organizerReminderQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.organizerReminderQuery,
  signingReminderQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.signingReminderQuery,
  signatureStatusQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.signatureStatusQuery,
  organizerStatusQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.organizerStatusQuery,
  sourceDocumentStatusQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.sourceDocumentStatusQuery,
  sortByQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.sortByQuery,
  sortOrderQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.sortOrderQuery,
  pageSizeQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.pageSizeQuery,
  pageNumberQuery: SSO_ArchivedAPI_ArchivedOrganizersParameter.pageNoQuery,
}

export const archivedOrganizerResponseBody: ArchivedOrganizerResponseBody = {
  ...baseResponseBody,
  data: {
    organizerId: SSO_ArchivedAPI_ArchivedOrganizersParameter.organizerId,
    clientName: SSO_ArchivedAPI_ArchivedOrganizersParameter.clientName,
    clientID: SSO_ArchivedAPI_ArchivedOrganizersParameter.clientID,
    taxpayerEmail: SSO_ArchivedAPI_ArchivedOrganizersParameter.taxpayerEmail,
    spouseEmail: SSO_ArchivedAPI_ArchivedOrganizersParameter.spouseEmail,
    taxYear: SSO_ArchivedAPI_ArchivedOrganizersParameter.taxYear,
    ero: SSO_ArchivedAPI_ArchivedOrganizersParameter.ero,
    deliveredDate: SSO_ArchivedAPI_ArchivedOrganizersParameter.deliveredDate,
    sentBy: SSO_ArchivedAPI_ArchivedOrganizersParameter.sentBy,
    batchName: SSO_ArchivedAPI_ArchivedOrganizersParameter.batchName,
    organizerReminder: SSO_ArchivedAPI_ArchivedOrganizersParameter.organizerReminder,
    signingReminder: SSO_ArchivedAPI_ArchivedOrganizersParameter.signingReminder,
    signatureStatus: SSO_ArchivedAPI_ArchivedOrganizersParameter.signatureStatus,
    organizerStatus: SSO_ArchivedAPI_ArchivedOrganizersParameter.organizerStatus,
    sourceDocumentStatus: SSO_ArchivedAPI_ArchivedOrganizersParameter.sourceDocumentStatus,
    locationId: SSO_ArchivedAPI_ArchivedOrganizersParameter.locationId,
  }
}

export const organizerCommonRequestBody: OrganizerCommonRequestBody = {
  requiredOrganizerId: SSO_Archived_APIs_commonParameter.organizerId,
  requiredCorrelationID: SSO_Archived_APIs_commonParameter.correlationId,
  callbackUri: SSO_Archived_APIs_commonParameter.callbackUri
}

export const resendAccessLinkRequestBody: ResendAccessLinkRequestBody = {
  organizerId: SSO_Archived_APIs_commonParameter.organizerId,
  correlationId: SSO_Archived_APIs_commonParameter.correlationId,
  signerGuid: SSO_ArchivedAPIs_ResendAccessLinkParameters.signerGuid,
}

export const signerDetailsRequestParameter: SignerDetailsRequestParameter = {
  organizerId: SSO_ArchivedAPI_SignerDetailsParameter.organizerIdQuery,
}

export const signerDetailsResponseBody: SignerDetailsResponseBody = {
  ...baseResponseBody,
  data: {
    name: SSO_ArchivedAPI_SignerDetailsParameter.name,
    emailAddress: SSO_ArchivedAPI_SignerDetailsParameter.emailAddress,
    signerGuid: SSO_ArchivedAPI_SignerDetailsParameter.signerGuid,
    signerType: SSO_ArchivedAPI_SignerDetailsParameter.signerType,
    signedOn: SSO_ArchivedAPI_SignerDetailsParameter.signedOn,
    signingOrder: SSO_ArchivedAPI_SignerDetailsParameter.signingOrder,
    isDeceased: SSO_ArchivedAPI_SignerDetailsParameter.isDeceased,
    signatureStatus: SSO_ArchivedAPI_SignerDetailsParameter.signatureStatus,
  }
}

export const deliveredOrganizerParameter: DeliveredOrganizerParameter = {
  clientIdQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.clientIDQuery,
  clientNameQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.clientNameQuery,
  taxpayerEmailQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.taxPayerEmailQuery,
  spouseEmailQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.spouseEmailQuery,
  sentByQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.sentByQuery,
  taxYearQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.taxYearQuery,
  batchNameQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.batchNameQuery,
  eroQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.eroQuery,
  deliveredAfterQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.deliveredAfterQuery,
  signingReminderQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.signingReminderQuery,
  organizerReminderQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.organizerReminderQuery,
  signatureStatusQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.signatureStatusQuery,
  organizerStatus: SSO_DeliveredAPI_DeliveredOrganizerParameter.organizerStatusQuery,
  sourceDocumentStatus: SSO_DeliveredAPI_DeliveredOrganizerParameter.sourceDocumentStatusQuery,
  sortByQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.sortByQuery,
  sortOrderQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.sortOrderQuery,
  pageNumberQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.pageNoQuery,
  pageSizeQuery: SSO_DeliveredAPI_DeliveredOrganizerParameter.pageSizeQuery,
}

export const deliveredOrganizerResponseBody: DeliveredOrganizerResponseBody = {
  ...baseResponseBody,
  data: {
    organizerId: SSO_DeliveredAPI_DeliveredOrganizerParameter.organizerId,
    clientName: SSO_DeliveredAPI_DeliveredOrganizerParameter.clientName,
    clientID: SSO_DeliveredAPI_DeliveredOrganizerParameter.clientID,
    taxpayerEmail: SSO_DeliveredAPI_DeliveredOrganizerParameter.taxpayerEmail,
    spouseEmail: SSO_DeliveredAPI_DeliveredOrganizerParameter.spouseEmail,
    taxYear: SSO_DeliveredAPI_DeliveredOrganizerParameter.taxYear,
    ero: SSO_DeliveredAPI_DeliveredOrganizerParameter.ero,
    deliveredDate: SSO_DeliveredAPI_DeliveredOrganizerParameter.deliveredDate,
    sentBy: SSO_DeliveredAPI_DeliveredOrganizerParameter.sentBy,
    batchName: SSO_DeliveredAPI_DeliveredOrganizerParameter.batchName,
    organizerReminder: SSO_DeliveredAPI_DeliveredOrganizerParameter.organizerReminder,
    signingReminder: SSO_DeliveredAPI_DeliveredOrganizerParameter.signingReminder,
    signatureStatus: SSO_DeliveredAPI_DeliveredOrganizerParameter.signatureStatus,
    organizerStatus: SSO_DeliveredAPI_DeliveredOrganizerParameter.organizerStatus,
    sourceDocumentStatus: SSO_DeliveredAPI_DeliveredOrganizerParameter.sourceDocumentStatus,
    locationId: SSO_DeliveredAPI_DeliveredOrganizerParameter.locationId,
  }
}

export const organizerSendReminderRequestBody: OrganizerSendReminderRequestBody = {
  organizerId: SSO_DeliveredAPI_SendReminderParameter.organizerId,
  correlationId: SSO_DeliveredAPI_SendReminderParameter.correlationId,
  engagementLetterReminder: SSO_DeliveredAPI_SendReminderParameter.engagementLetterReminder,
  organizerReminder: SSO_DeliveredAPI_SendReminderParameter.organizerReminder,
  sourcedDocumentReminder: SSO_DeliveredAPI_SendReminderParameter.sourceDocumentReminder
}

export const deliveredSignerDetailsRequestParameter: OrganizerSignerDetailsRequestParameter = {
  organizerId: SSO_DeliveredAPI_SignerDetailsParameter.organizerIdQuery,
}

export const organizerDeleteInProcessRequestBody: OrganizerDeleteInProcessRequestBody = {
  organizerId: SSO_InProcessAPI_DeleteInProcessOrganizerParameter.organizerId,
  correlationId: SSO_InProcessAPI_DeleteInProcessOrganizerParameter.correlationId,
  callbackUri: SSO_InProcessAPI_DeleteInProcessOrganizerParameter.callbackUri,
}

export const inProcessOrganizersRequestParameter: InProcessOrganizersRequestParameter = {
  clientNameQuery: SSO_InProcessAPI_GetAllParameter.nameQuery,
  clientIdQuery: SSO_InProcessAPI_GetAllParameter.clientIdQuery,
  eroQuery: SSO_InProcessAPI_GetAllParameter.eroSignerQuery,
  assignedToQuery: SSO_InProcessAPI_GetAllParameter.assignedToQuery,
  organizerStatusQuery: SSO_InProcessAPI_GetAllParameter.organizerStatusQuery,
  uploadedAfterQuery: SSO_InProcessAPI_GetAllParameter.uploadedAfterQuery,
  taxReturnType: SSO_InProcessAPI_GetAllParameter.taxReturnTypeQuery,
  taxYearQuery: SSO_InProcessAPI_GetAllParameter.taxYearQuery,
  pageSizeQuery: SSO_InProcessAPI_GetAllParameter.pageSizeQuery,
  pageNumberQuery: SSO_InProcessAPI_GetAllParameter.pageNoQuery,
  sortByQuery: SSO_InProcessAPI_GetAllParameter.sortByQuery,
  sortOrderQuery: SSO_InProcessAPI_GetAllParameter.sortOrderQuery,
}

export const inProcessOrganizersResponseBody: InProcessOrganizersResponseBody = {
  ...baseResponseBody,
  data: {
    organizerId: SSO_InProcessAPI_GetAllParameter.organizerId,
    organizerName: SSO_InProcessAPI_GetAllParameter.organizerName,
    clientID: SSO_InProcessAPI_GetAllParameter.clientId,
    taxYear: SSO_InProcessAPI_GetAllParameter.taxYear,
    ero: SSO_InProcessAPI_GetAllParameter.eroSigner,
    assignedTo: SSO_InProcessAPI_GetAllParameter.assignedTo,
    status: SSO_InProcessAPI_GetAllParameter.status,
    uploadedDate: SSO_InProcessAPI_GetAllParameter.uploadedDate,
    taxReturnType: SSO_InProcessAPI_GetAllParameter.taxReturnType,
    locationId: SSO_InProcessAPI_GetAllParameter.locationId,
  }
}

export const recycleBinOrganizerParameter: RecycleBinOrganizerParameter = {
  clientIdQuery: SSO_RecycleBinAPI_GetAllParameter.clientIDQuery,
  clientNameQuery: SSO_RecycleBinAPI_GetAllParameter.clientNameQuery,
  taxYearQuery: SSO_RecycleBinAPI_GetAllParameter.taxYearQuery,
  eroQuery: SSO_RecycleBinAPI_GetAllParameter.eroQuery,
  batchNameQuery: SSO_RecycleBinAPI_GetAllParameter.batchNameQuery,
  sentByOrganizerQuery: SSO_RecycleBinAPI_GetAllParameter.sentByQuery,
  deliveredAfterQuery: SSO_RecycleBinAPI_GetAllParameter.deliveredAfterQuery,
  signatureStatusQuery: SSO_RecycleBinAPI_GetAllParameter.signatureStatusQuery,
  organizerStatus: SSO_RecycleBinAPI_GetAllParameter.organizerStatusQuery,
  sourceDocumentStatusQuery: SSO_RecycleBinAPI_GetAllParameter.sourceDocumentStatusQuery,
  deletedByQuery: SSO_RecycleBinAPI_GetAllParameter.deletedByQuery,
  deletedAfterQuery: SSO_RecycleBinAPI_GetAllParameter.deletedAfterQuery,
  sortByQuery: SSO_RecycleBinAPI_GetAllParameter.sortByQuery,
  sortOrderQuery: SSO_RecycleBinAPI_GetAllParameter.sortOrderQuery,
  pageSizeQuery: SSO_RecycleBinAPI_GetAllParameter.pageSizeQuery,
  pageNumberQuery: SSO_RecycleBinAPI_GetAllParameter.pageNoQuery,
}

export const recycleBinOrganizerResponseBody: RecycleBinOrganizerResponseBody = {
  ...baseResponseBody,
  data: {
    batchName: SSO_RecycleBinAPI_GetAllParameter.batchName,
    clientID: SSO_RecycleBinAPI_GetAllParameter.clientID,
    clientName: SSO_RecycleBinAPI_GetAllParameter.clientName,
    deliveredDate: SSO_RecycleBinAPI_GetAllParameter.deliveredDate,
    ero: SSO_RecycleBinAPI_GetAllParameter.ero,
    organizerId: SSO_RecycleBinAPI_GetAllParameter.organizerId,
    organizerStatus: SSO_RecycleBinAPI_GetAllParameter.organizerStatus,
    sentBy: SSO_RecycleBinAPI_GetAllParameter.sentBy,
    signatureStatus: SSO_RecycleBinAPI_GetAllParameter.signatureStatus,
    sourceDocumentStatus: SSO_RecycleBinAPI_GetAllParameter.sourceDocumentStatus,
    taxYear: SSO_RecycleBinAPI_GetAllParameter.taxYear,
    deletedBy: SSO_RecycleBinAPI_GetAllParameter.deletedBy,
    deletedDate: SSO_RecycleBinAPI_GetAllParameter.deletedDate,
    locationId: SSO_RecycleBinAPI_GetAllParameter.locationId,
  }
}

export const organizerStatusRequestParameter: OrganizerStatusRequestParameter = {
  organizerIdQuery: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.organizerIdQuery,
}

export const organizerStatusResponseBody: OrganizerStatusResponseBody = {
  ...baseResponseBody,
  data: {
    organizerId: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.organizerId,
    clientId: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.clientId,
    organizerStatus: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.organizerStatus,
    lastOrganizerReminder: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.lastOrganizerReminder,
    signatureStatus: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.signatureStatus,
    lastSignatureReminder: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.lastSignatureReminder,
    sourceDocumentStatus: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.sourceDocumentStatus,
    isArchived: SSO_OrganizerStatusAPI_GetOrganizerStatusParameter.isArchived
  }
}

export const updateDocumentStatusRequestBody: UpdateDocumentStatusRequestBody = {
  documentGuid: SSO_OrganizerStatusAPI_updateDocumentStatusParameter.documentGuid,
  fileNames: SSO_OrganizerStatusAPI_updateDocumentStatusParameter.fileNames,
  documentType: SSO_OrganizerStatusAPI_updateDocumentStatusParameter.documentType
}